import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withTheme } from "styled-components";
import history from "../../../../modules/history";
import SurveyReader from "../../../library/SurveyReader/SurveyReader";
import { ToastType } from "../../../ToastManager/constants";
import { sendNotification } from "../../../ToastManager/ToastManager";
import { Spinner } from "react-bootstrap";
import {
  mapDispatchToProps,
  mapStateToProps,
  singleNextStepReducer,
} from "./SingleNextStep.store";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const SurveyContainer = styled.div`
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
`;

const CompletedContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme?.white};
  max-width: 1000px;
  height: 600px;
  margin-left: auto;
  margin-right: auto;

  span {
    margin-top: auto;
    font-size: 26px;
    color: ${(props) => props.theme?.nero};
    text-align: center;
  }
`;

export const SmartSingleNextStep = ({
  fetchSurvey,
  surveyData,
  resetState,
  surveyId,
  sendSurveyResponse,
}) => {
  const { t } = useTranslation();
  const [isSurveyCompleted, setIsSurveyCompleted] = useState(false);
  useEffect(() => {
    if (!surveyData && surveyId)
      fetchSurvey(surveyId).catch((error) => {
        sendNotification(error, ToastType.ERROR);
      });
  }, [fetchSurvey, surveyData, surveyId]);

  useEffect(() => {
    return () => resetState();
  }, [resetState]);

  const handleSurveyComplete = () => {
    setIsSurveyCompleted(true);
    sendSurveyResponse(surveyId)
      .then(() => {
        setTimeout(() => {
          history.push("/participant");
        }, 3000);
      })
      .catch((error) => {
        sendNotification(error, ToastType.ERROR);
      });
  };

  return !isSurveyCompleted ? (
    <SurveyContainer>
      <SurveyReader
        surveyData={surveyData}
        onComplete={() => handleSurveyComplete()}
      />
    </SurveyContainer>
  ) : (
    <CompletedContainer>
      <span>{t("appText.survey.completed")}</span>
      <Spinner
        data-testid="spinner"
        className="d-flex mx-auto mt-4 mb-auto"
        animation="border"
      />
    </CompletedContainer>
  );
};

export default withTheme(
  dynamic(
    "singleNextStepReducer",
    subspaced({
      mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
    }),
    attachReducer(singleNextStepReducer)
  )(connect(mapStateToProps, mapDispatchToProps)(SmartSingleNextStep))
);
